import { render, staticRenderFns } from "./FeaturedActivities.vue?vue&type=template&id=2f66028c&scoped=true&"
import script from "./FeaturedActivities.vue?vue&type=script&lang=js&"
export * from "./FeaturedActivities.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedActivities.vue?vue&type=style&index=0&id=2f66028c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f66028c",
  null
  
)

export default component.exports